import {Inject, Injectable} from "@angular/core";
import {BehaviorSubject, catchError, map, of, Subject} from "rxjs";
import {tagAggregateDtoDto, TagDto, tagDtoToCustomTag} from "../domain";
import {
  CreateNewTagUseCase,
  DeleteTagUseCase,
  EditTagUseCase,
  FindTagUseCase,
  ListCustomTagsUseCase
} from "../../use-cases";

@Injectable()
export class TagsDetailFacade {
  private _deleteConfirm$ = new Subject<void>()

  constructor(
    @Inject(CreateNewTagUseCase) private createTagUseCase: CreateNewTagUseCase,
    @Inject(ListCustomTagsUseCase) private listTagsUseCase: ListCustomTagsUseCase,
    @Inject(FindTagUseCase) private findTagUseCase: FindTagUseCase,
    @Inject(EditTagUseCase) private editTagUseCase: EditTagUseCase,
    @Inject(DeleteTagUseCase) private deleteTagUseCase: DeleteTagUseCase) {
  }

  private _currentTag$ = new BehaviorSubject<number>(0)

  get currentTag$() {
    return this._currentTag$.asObservable()
  }

  private _saveConfirm$ = new Subject<void>()

  get saveConfirm$() {
    return this._saveConfirm$.asObservable()
  }

  get currentTag() {
    return this._currentTag$.getValue()
  }

  get confirmDelete$() {
    return this._deleteConfirm$.asObservable()
  }

  createTag(params: TagDto) {
    return this.createTagUseCase.execute(tagDtoToCustomTag(params))
      .pipe(map(tagAggregateDtoDto), catchError(() => of(null)))
  }

  editTag(params: TagDto) {
    return this.editTagUseCase.execute(tagDtoToCustomTag(params))
      .pipe(map(tagAggregateDtoDto), catchError(() => of(null)))
  }

  listTagsFromCompanies(companiesId: string[]) {
    return this.listTagsUseCase.execute({companiesId})
      .pipe(map(tags => tags.map(tagAggregateDtoDto)))
  }

  deleteTag(id: number) {
    return this.deleteTagUseCase.execute({id})
  }

  findTagById(id: number) {
    return this.findTagUseCase.execute({id}).pipe(map(tagAggregateDtoDto))
  }

  setCurrentTag(tagId: number) {
    this._currentTag$.next(tagId)
  }

  confirmDelete() {
    this._deleteConfirm$.next()
  }

  confirmSave() {
    this._saveConfirm$.next()
  }

  validateTag(tag: TagDto) {
    tagDtoToCustomTag(tag)

    return tag;
  }
}
